export const LeaveClassromActionTypes = {
    OPEN_LEAVE_CLASSROOM_PAGE: 'OPEN_LEAVE_CLASSROOM_PAGE',
    CLOSE_LEAVE_CLASSROOM_PAGE: 'CLOSE_LEAVE_CLASSROOM_PAGE',
};